// extracted by mini-css-extract-plugin
module.exports = {"navIcon":"viAl4","rc-tabs-bar":"mIqNB","rc-tabs-tab":"-sAVZ","rc-tabs-tab-active":"EvcNc","terms":"O+kVf","orderHistory-navigation":"pAgbZ","invalidItem":"_6Ur69"};